export function t(key, fallback = '', replacements = {}) {
    const root = (typeof window !== 'undefined' && window.__translations) || {};
    const checkoutTranslations = (typeof window !== 'undefined' && window.__checkout_translations) || {};

    const resolveFrom = (dict, path) => {
        const keys = path.split('.');
        let val = dict;
        for (const k of keys) {
            if (val && typeof val === 'object' && k in val) {
                val = val[k];
            } else {
                return undefined;
            }
        }
        return (typeof val === 'string' || typeof val === 'number') ? String(val) : undefined;
    };

    let value = resolveFrom(root, key);
    if (value === undefined) {
        value = resolveFrom(checkoutTranslations, key);
    }

    let result = value !== undefined ? value : (fallback || key);

    if (replacements && typeof replacements === 'object') {
        for (const [rKey, rVal] of Object.entries(replacements)) {
            result = result.replace(new RegExp(`:${rKey}`, 'g'), String(rVal));
        }
    }

    return result;
}

export default function useTranslation() {
    return { t };
}
